import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Flex, Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
/**
 * Renders the attendees who cannot attend a suggested time: a single avatar
 * with their name, or an avatar group with a count.
 */
export var ConflictDetail = function (_a) {
    var token = _a.token, conflicts = _a.conflicts;
    var t = useTranslation('meetingRooms').t;
    var summary = conflicts.length === 1
        ? t('time_suggestions.one_cannot_attend', { name: conflicts[0].name })
        : t('time_suggestions.count_cannot_attend', { count: conflicts.length });
    return (_jsxs(Flex, { align: "center", gap: 8, style: { width: '100%' }, children: [conflicts.length === 1 ? (_jsx(Avatar, { size: 28, name: conflicts[0].name, src: conflicts[0].src })) : (_jsx(Avatar.Group, { size: 28, max: { count: 4 }, children: conflicts.map(function (attendee) { return (_jsx(Avatar, { name: attendee.name, src: attendee.src }, attendee.id)); }) })), _jsx(Typography.Text, { style: { fontSize: 12, color: token.colorTextHeading }, children: summary })] }));
};
